import { API_ONEPLATFORM_TASKS } from 'services/dataService/resources/oneplatform/constants';

import type { TabKey } from './types';

export const TASKS_API_URL = API_ONEPLATFORM_TASKS;

export const QUERY_KEYS = {
  dashboardTasks: 'dashboardTasks',
  tasksBadgeCount: 'tasksBadgeCount',
} as const;

export const TAB_KEYS: Record<string, TabKey> = {
  OPEN_POOL: 'open_pool',
  ASSIGNED_TO_ME: 'assigned_to_me',
  COMPLETED: 'completed',
} as const;

export const DEFAULT_PAGE_LIMIT = 30;
